<template>
<section style="margin:auto; max-width:900px">
 
<div class="card" style="border:0px; padding:20px">
    <div class="card-body">
        <div class="row">
            <div class="col-md-2">
                <img src="public/images/site/profile.svg" style="max-width: 100px;" class="img img-rounded img-fluid"/>
            </div>
            <div class="col-md-10">
                <p>
                    <strong>Julieta </strong>madre de una Arkidian de 9 años

               </p>
               <p>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
              </p>
               <div class="clearfix"></div>
                <p>Arkidia es fantástico. Saca el lado creativo de mi hija y desarrolla talentos y habilidades diferentes a los del colegio</p>

            </div>
        </div>
    </div>
</div>
   <div class="card" style="border:0px; padding:20px">
    <div class="card-body">
        <div class="row">
            <div class="col-md-2">
                <img src="public/images/site/profile.svg" style="max-width: 100px;" class="img img-rounded img-fluid"/>
            </div>
            <div class="col-md-10">
                <p>
                    <strong>Martín</strong>, abuelo de un Arkidian de 7 años

               </p>
               <p>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
              </p>
               <div class="clearfix"></div>
                <p>Exploramos con mi nieto todas las categorías, con actividades tan diversas. Hay algo para todos!!</p>

            </div>
        </div>
    </div>
</div>
<div class="card" style="border:0px; padding:20px">
    <div class="card-body">
        <div class="row">
            <div class="col-md-2">
                <img src="public/images/site/profile.svg" style="max-width: 100px;" class="img img-rounded img-fluid"/>
            </div>
            <div class="col-md-10">
                <p>
                    <strong>María Luisa</strong>, madre de dos Arkidians de 8 y 10 años
               </p>
               <p>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
              </p>
               <div class="clearfix"></div>
                <p>Descubrí una gran manera de que usen el celular pero que después tengan que dejarlo para hacer los desafíos que proponen.</p>

            </div>
        </div>
    </div>
</div>


<div class="card" style="border:0px; padding:20px">
    <div class="card-body">
        <div class="row">
            <div class="col-md-2">
                <img src="public/images/site/profile.svg" style="max-width: 100px;" class="img img-rounded img-fluid"/>
            </div>
            <div class="col-md-10">
                <p>
                    <strong>Edison y Lucrecia</strong>, padres de un Arkidian de 9 años
               </p>
               <p>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
                  <img src="public/images/site/star.svg" style="width:20px"/>
              </p>
               <div class="clearfix"></div>
                <p>Desde que nuestro hijo empezó a jugar con Arkidia está más creativo en su tiempo libre, atento a lo que aprendió y a las cosas que puede compartir con otros niños. Bravo! </p>

            </div>
        </div>
    </div>
</div>

        </section>

</template>

<script>
import { mapGetters } from 'vuex'

  export default {
    
    name: 'app',

    data () {
      return {
        errorMessage:"",
        login:{
          usuario:"",
          password:""
          }
      }
    },

    computed:{
    ...mapGetters(['pathAPI','userLogged']),

    },

    methods:{
     
    },

    computed:{

    }
        ,
    components:{

    },

    mounted: function(){

    },


  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/startPage/CommentsBanner.vue